module.exports = __webpack_public_path__ + "static/appleville_live-ccf814b1d02fdb8292bd00ef88448b11.png";